export default class LoginPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initInput();
  }

  initInput() {
    const form = this.dom;
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        let email = form.querySelector("#input-email").value;
        let canPass = this.validateEmail(email);
        let errorMesssage = form.querySelector(".wpforms-error");
        if (canPass) {
          form.submit();
          errorMesssage.classList.add("d-none");
        } else {
          errorMesssage.classList.remove("d-none");
        }
      });
    }
  }

  validateEmail(email) {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email);
  }

  resize() {}
}
